import React from 'react';
import FeatureSpotlight from './FeatureSpotlight';
import stayConnectedImg from '../../assets/images/stayconnected.png';
import onlineBankingImg from '../../assets/images/Online-3.png';

const HomeFeatureSpotlights = () => (
  <>
    <FeatureSpotlight
      variant="muted"
      title="Stay connected on the go"
      description="Check balances, transfer money, and deposit checks from your phone—securely, wherever you are."
      ctaLabel="Explore mobile banking"
      ctaHref="/MobileBanking"
      imageSrc={stayConnectedImg}
      imageAlt="GN Bank mobile app on a smartphone"
      imagePosition="left"
    />
    <FeatureSpotlight
      variant="white"
      title="Online banking, made clear"
      description="Manage accounts, pay bills, and stay on top of your money from home with secure digital banking."
      ctaLabel="Explore online banking"
      ctaHref="/OnlineBanking"
      imageSrc={onlineBankingImg}
      imageAlt="GN Bank online banking"
      imagePosition="right"
    />
  </>
);

export default HomeFeatureSpotlights;
